import React from 'react';
import { GraduationCap, Award, Globe } from 'lucide-react';

import Chatbot from '../images/Chatbot.jpeg';
import DataAnalyst from '../images/Data_analyst.png';
import ExpertSQL from '../images/Devenir_expert_sql.jpg';
import LeafAward from '../images/Leaf_Doctor_award.jpeg';
import Recommandation from '../images/Lettre_recommandation_yassine_shah.png';
import SnowflakeCert from '../images/Ultimate_Snowflake_SnowPro.jpg';

const images = [
  Chatbot,
  DataAnalyst,
  ExpertSQL,
  LeafAward,
  Recommandation,
  SnowflakeCert
];


const About = ({ data, education }) => {
  const languages = [
    { name: "Arabic", level: "Native" },
    { name: "French", level: "C2 - Professional" },
    { name: "English", level: "C1 - Advanced" }
  ];

  const awards = [
    "Astronomer: Apache Airflow 3 Fundamentals",
    "Udacity Nanodegree: Data Analysis (ALX-T)",
    "Udemy: Snowflake SnowPro Core Certification, SQL Expert",
    "Coursera: Design Thinking for Innovation",
    "Kaggle: Machine Learning Certifications",
    "First Prize - Orange AI & ENSAM Competition (2023)",
    "First Prize - AI&ML Summer Competition (2022)",
    
  ];

  return (
    <section id="about" className="about-section">
      <div className="about-container">
        <div className="section-header">
          <span className="label">ABOUT ME</span>
          <h2 className="title-big">WHO I AM</h2>
        </div>

        <div className="about-content">
          <div className="about-main">
            <div className="about-text">
              <p className="text-regular">
                {data.bio}
              </p>
              <p className="text-body">
                Ambitious and creative, I bring ideas to life through practical action.  
                I adapt fast, think clearly under pressure, and always aim for results.  
                Whether working solo or in a team, I focus on efficiency and impact.  
                I don’t follow trends, I solve problems.<br /><br />
                My experience encompasses data engineering, AI model development, Kubernetes orchestration, 
                and cloud deployment. I have worked on complex enterprise and research projects, with a 
                strong focus on quality, security, and business impact.
              </p>
            </div>

            <div className="about-highlights">
              <div className="highlight-item">
                <span className="highlight-number ">&gt; 96%</span>
                <span className="highlight-label label-small">MODELS ACCURACY</span>
              </div>
              <div className="highlight-item">
                <span className="highlight-number ">100%</span>
                <span className="highlight-label label-small">ANOMALY REDUCTION</span>
              </div>
              <div className="highlight-item">
                <span className="highlight-number ">&gt; 15 </span>
                <span className="highlight-label label-small">Dashboard</span>
              </div>
            </div>

            <div className="galerie-container">
                {images.map((src, index) => (
        <img
          key={index}
          src={src}
          alt={`image-${index}`}
          className="galerie-image"
        />
      ))}
          </div>
          </div>

          <div className="about-sidebar">
            <div className="about-section-card">
              <div className="card-header">
                <GraduationCap size={20} />
                <h3 className="text-regular">Education</h3>
              </div>
              <div className="education-list">
                {education.map((edu, index) => (
                  <div key={index} className="education-item">
                    <span className="label-small">{edu.period}</span>
                    <h4 className="text-body">{edu.degree}</h4>
                    <p className="text-body institution ">{edu.institution}</p>
                    <span className="location text-body">{edu.location}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="about-section-card">
              <div className="card-header">
                <Globe size={20} />
                <h3 className="text-regular">Languages</h3>
              </div>
              <div className="languages-list">
                {languages.map((lang, index) => (
                  <div key={index} className="language-item">
                    <span className="text-body">{lang.name}</span>
                    <span className="label-small">{lang.level}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="about-section-card">
              <div className="card-header">
                <Award size={20} />
                <h3 className="text-regular">Awards & Certifications</h3>
              </div>
              <div className="awards-list">
                {awards.map((award, index) => (
                  <div key={index} className="award-item">
                    <span className="text-body">{award}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;